import { atom } from "@workflows/runtime-web";
export const dcocomWhistleblowIntakeFormStep = atom({
  key: "dcocomWhistleblowIntakeFormState",
  default: 1
});
export const dcocomWhistleblowIntakeFormIsAnonymous = atom({
  key: "dcocomWhistleblowIntakeFormIsAnonymous",
  default: false
});
export const dcocomWhistleblowIntakeFormMatterId = atom({
  key: "dcocomWhistleblowIntakeFormMatter",
  default: ""
});
export const dcocomWhistleblowIntakeFormCode = atom({
  key: "dcocomWhistleblowIntakeFormCode",
  default: ""
});
export const dcocomWhistleblowIntakeFormURLs = ["/whistleblow/content", "/whistleblow/submit"];